import React from "react";
import { STATUS_COLOR_MAP } from "../../constants/leadStatusColors";

function LeadStatusBadge({ status }) {
  const statusMap = {
    New: "new",
    Contacted: "contacted",
    Qualified: "qualified",
    "Demo Scheduled": "demo-scheduled",
    "Demo Completed": "demo-completed",
    Won: "won",
    Lost: "lost",
  };

  const className = statusMap[status] || "new";
  const colors = STATUS_COLOR_MAP[status];

  return (
    <span
      className={`status-badge ${className}`}
      style={colors ? { background: colors.bg, color: colors.fg } : undefined}
    >
      {status || "New"}
    </span>
  );
}

export default LeadStatusBadge;